module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{},"fr":{},"it":{}}')
  delete Component.options._Ctor
}
